import { useEffect } from "react";

import { useCashSession } from "../../hooks/cash/useCashSession";
import { useCashSummary } from "../../hooks/cash/useCashSummary";

import CashSummaryView from "./CashSummaryView";

const CashSummaryCard = () => {

  const { activeSession, getActiveSession } = useCashSession();
  const { summary, getSummary } = useCashSummary();

  useEffect(() => {
    if (!activeSession) {
      getActiveSession();
    }
  }, []);

  useEffect(() => {
    if (activeSession?.id) {
      getSummary(activeSession.id);
    }
  }, [activeSession?.id]);

  /**
   * ❌ SIN SESIÓN → NO RENDERIZA
   */
  if (!activeSession) return null;

  return (
    <CashSummaryView
      data={summary}
      showNoSession={false}
    />
  );
};

export default CashSummaryCard;